<div class="change-order-form dropdown-content-root">
	<div class="change-simple-order">
		<div class="dropdown-title">
			<h4 class="title">{{ 'changeOrder.title' | translate }}</h4>
			<tui-icon
				class="close-icon"
				icon="@tui.x"
				(click)="onCloseDropdown()"
			/>
		</div>

		<div class="details">
			<div class="detail">
				<span class="title">{{ 'changeOrder.option' | translate }}</span>
				<div class="ticker">
					<span class="text">{{ order()?.option_ticker }}</span>
					<span class="text">{{ order()?.option_strike | price }}</span>
					<span
						class="text"
						highlight
						[isPositive]="order()?.option_type === optionTypeEnum.CALL"
						[isNegative]="order()?.option_type === optionTypeEnum.PUT"
						>{{ order()?.option_type | uppercase }}</span
					>
					<span class="text">{{ order()?.option_date | date: 'dd.MM.yyyy' }}</span>
				</div>
			</div>

			<div class="detail">
				<span class="title">{{ 'changeOrder.operation' | translate }}</span>
				<span
					class="value"
					highlight
					[isPositive]="order()?.side === orderSideEnum.BUY"
					[isNegative]="order()?.side === orderSideEnum.SELL"
					>{{ `changeOrder.side.${order()?.side}` | translate }}</span
				>
			</div>

			<div class="detail">
				<span class="title">{{ 'changeOrder.orderType' | translate }}</span>
				<span class="value">{{ 'changeOrder.types.' + order()?.type | translate }}</span>
			</div>

			<div class="detail">
				<span class="title">{{ 'changeOrder.orderDuration' | translate }}</span>
				<span class="value">{{ order()?.time_in_force | uppercase }}</span>
			</div>

			@if (order()?.limit_price) {
				<div class="detail">
					<span class="title">{{ 'changeOrder.limitPrice' | translate }}</span>
					<span class="value">
						{{ order()?.limit_price | price }}
					</span>
				</div>
			}

			<div class="detail">
				<span class="title">{{ 'changeOrder.quantity' | translate }}</span>
				<span class="value">{{ order()?.qty | quantity }}</span>
			</div>
		</div>

		@if (form) {
			<form
				class="form"
				[formGroup]="form"
				(ngSubmit)="onSubmit()"
			>
				@if (order()?.limit_price) {
					<app-order-price-input
						label="changeOrder.limitPrice"
						[control]="form.get('limit_price')"
					/>
				}

				<app-button
					appearance="primary"
					size="l"
					type="submit"
					[isLoading]="isLoading()"
				>
					{{ 'changeOrder.edit' | translate }}
				</app-button>
			</form>
		}
	</div>
</div>
